import React from 'react';
import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useCallPatternTable from './hooks/useCallPatternTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabCallPattern = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    setColumns,
    columns,
    newRecord,
    spinning,
    postData,
    createNewRecord,
    handleUpdateRows,
    onListRender,
    resetNewRecord,
    dataSource,
    handleClearFilter,
    handleRemoveRecords,
  } = useCallPatternTable();

  return (
    <>
      {spinning && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource || []}
            onListRender={onListRender}
            columns={columns}
            setColumns={setColumns}
            autocompleteFieldProvider={autocompleteFieldSearch}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortModelChange}
            onDeleteClick={handleRemoveRecords}
            scroll={{ y: '60vh', x: '90vw' }}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='call-pattern-table'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            total
            showAutoIncrement
            handleUpdateRows={handleUpdateRows}
            newRecord={newRecord}
            postData={postData}
            saveNewRecord={createNewRecord}
            resetNewRecord={resetNewRecord}
            clearFilter={handleClearFilter}
            columnFilterShown
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};
export default TabCallPattern;
